











































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { LocationListModule } from '@/store/modules/locationList';

@Component({
    name: 'LocationListEmail'
})
export default class extends GiganautVueDialog {

  emailAddresses = '';
  copied = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.copied = false;
      this.emailAddresses = '';
      let emails = '';
      for (let index = 0; index < LocationListModule.locations.length; index++) {
        const location = LocationListModule.locations[index];
        if (location.emailAddress !== ''){
            if (emails != '') {
              emails = emails + '; ';
            }
            emails = emails + location.emailAddress;
        }       
      }
      this.emailAddresses = emails;
    }
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.emailAddresses);
      this.copied = true;
    } catch (err) {
      this.copied = false;
    }
  }
}
